import React, { useState, useEffect, useContext } from 'react'
import DoctorForm from '../doctor-form/DoctorForm'
import DoctorService from '../../../../../services/api/doctor.service'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import { store } from '../../../../../context/StateProvider'

const EditDoctor = (props) => {
    const { id, inputChange } = props;
    const [formData, setFormData] = useState({})
    const [isLoaded_form, setIsLoaded_form] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch

    const onSuccess = (message) => {
        dispatch({
            type: "setLocationProviderServices",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    useEffect(() => {
        DoctorService.getById(id)
            .then(res => {
                res.phone = res.mobile;
                res.doctorTypeCode = res.doctorType;
                setFormData(res)
                setIsLoaded_form(true)
            })
            .catch(err => {
                console.log(err);
            })
    }, [])

    const submitHandler = (data) => {
        setIsLoader(true)
        const reqObj = {
            doctorTypeCode: data.doctorTypeCode? data.doctorTypeCode : '',
            doctorTypeName: data.doctorTypeCode? data.doctorTypeCode : '',
            firstName: data.firstName,
            lastName: data.lastName,
            mobile: data.phone.includes("(") ? data.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "") : data.phone,
            phone: data.phone.includes("(") ? data.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "") : data.phone,
            email: data.email,
            npi: data.npi ? data.npi : '',
            address: data.address,
        }
        DoctorService.update(reqObj, id)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            })
    }

    return (
        <>
        {isLoader && <DimLoader />}
            {isLoaded_form && <DoctorForm isEdit submitHandler={submitHandler} initialData={formData} inputChange={inputChange} onClose={() => props.onClose()} loaded={isLoaded_form}/>}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default EditDoctor